import Utils from '@/utils/util';
import { ServiceTip } from '../types';
import './ServiceTipCard.scss';
import { useTranslation } from 'react-i18next';
import UserIcon from '@/assets/img/user-default-icon.png';
import { ServiceTypes } from '@/components/Elements/ServiceTypes';
import { useAuth } from '@/lib/auth';
import { businessCurrency } from '@/features/Language/api/getCountryCurrency';

export type ServiceCardProps = {
  data: ServiceTip;
  isLast?: boolean;
  showPaymentDetails?: (data: ServiceTip) => void;
};

export const ServiceTipCard = ({ data, isLast, showPaymentDetails }: ServiceCardProps) => {
  const { user } = useAuth();
  const currency = businessCurrency(user, 'USD');
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className={`service-tip-card ${isLast ? 'last-child' : ''}`}>
        <div className="detail-row center">
          <span className="label">Customer</span>
          <div className="details">
            <div className="customer-details">
              <img
                src={
                  data?.appointment?.petParent?.avatarUrl
                    ? data?.appointment?.petParent?.avatarUrl
                    : UserIcon
                }
              />
              <div className="details">
                <div className="name">{data?.appointment?.petParent?.name}</div>
                <a onClick={() => showPaymentDetails && showPaymentDetails(data)}>
                  Appt ID #{data?.appointmentId}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="detail-row center">
          <span className="label">Services</span>
          <div className="details">
            <ServiceTypes
              services={data?.appointment?.service ? [data?.appointment?.service] : []}
              restrictService={true}
            />
            <div />
          </div>
        </div>
        <div className="detail-row center">
          <span className="label">Payment date</span>
          <div className="details">
            {Utils.getOnlyDate(data?.paymentDate, 'MMM DD, yyyy')}
            <span className="date-seperator"></span>
            {Utils.getAMPMtimeWithoutFormat(data?.paymentDate)}
          </div>
        </div>

        <div className="detail-row center">
          <span className="label">Tip amount</span>
          <div className="details">
            +{currency}
            {Utils.formatAmount(data.serviceTip)}{' '}
          </div>
        </div>
      </div>
    </>
  );
};

ServiceTipCard.displayName = 'Service Tip Card';
